import React from "react";

import Profile from "../features/profile/Profile.component";

const ProfilePage = () => {
  return <Profile />;
};

export default ProfilePage;
